import { render, staticRenderFns } from "./StackedCards.vue?vue&type=template&id=beb7cbdc&"
import script from "./StackedCards.vue?vue&type=script&lang=ts&"
export * from "./StackedCards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports